/**
 * The built-in shower (defs/shower.ts) as a data spec: the shower plan symbol
 * (assets/shower.svg) traced into polylines at the default size. The shapes are
 * in one `stretch` group, so the symbol stretches with the footprint along
 * both axes — exactly like the built-in SVG glyph, which is normalized to
 * the footprint box.
 */

import { OBJECT_DEFINITION_SCHEMA_VERSION, type ObjectDefinitionSpec } from 'shared-types';
import showerSvg from '../../assets/shower.svg?raw';
import { svgSymbolShapes } from './svgSymbol';

const W = 0.9;
const D = 0.9;

const shapes = svgSymbolShapes('shower', showerSvg, W, D, 'shower', 'Shower');

export const showerSpec: ObjectDefinitionSpec = {
  schemaVersion: OBJECT_DEFINITION_SCHEMA_VERSION,
  anchor: 'POINT',
  constraint: { kind: 'FREE' },
  defaultSize: { width: W, depth: D, height: 2.1 },
  params: [],
  shapes,
  groups: [{ id: 'symbol', name: 'Shower symbol', shapeIds: shapes.map((s) => s.id), resize: { u: 'stretch', n: 'stretch' } }],
  model3d: null,
};
